export default __webpack_public_path__ + "static/media/brokenCar.dd94d309.webp";